module.exports = __webpack_public_path__ + "media/images/7-b7f2395d.png";